<!--
발송작업 > 배송상품
-->
<template>
    <div class="uk-card uk-card-default simple-card uk-card-small">

        <div class="uk-card-body p-1rem">

            <div class="title">
                <i class="material-icons">local_shipping</i>
                <span class="uk-text-middle">배송상품 (검수하세요)</span>
            </div>

            <div class="uk-flex uk-flex-between">

                <div class="uk-width-auto">

                    <!-- 이미지 -->
                    <img-zoom :src="shipProd.img_url" disable-preview style="width: 30rem; height: 30rem"></img-zoom>

                    <!-- 해외상세 버튼 -->
                    <div class="uk-text-center uk-margin-top">
                        <button
                            type="button"
                            class="uk-button uk-button-default"
                            onclick="$.app.on_event.move(arguments);"
                            :data-url="shipProd.vender_url"
                            data-target="_blank"
                        >
                            <i class="material-icons">
                                link
                            </i>
                            해외상세
                        </button>
                    </div>
                </div>

                <div class="uk-width-expand uk-text-center">

                    <!-- 상품정보 -->
                    <table class="prod-info mb-1rem">

                        <tr>
                            <th>
                                보관장소
                            </th>
                            <td class="bold" colspan="5">
                                {{ shipProd.storage }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                상품번호
                            </th>
                            <td>
                                <div class="uk-flex uk-flex-middle">
                                    <div class="uk-width-expand">
                                        {{ shipProd.id_3digits }}
                                    </div>


                                    <!-- 상세버튼 -->
                                    <button
                                        type="button"
                                        class="uk-button uk-button-white"
                                        onclick="$.app.on_event.move(arguments);"
                                        :data-url="'/prods/' + shipProd.id"
                                        data-target="_blank"
                                    >
                                        <span uk-icon="icon: link"></span>
                                        상품상세
                                    </button>
                                </div>


                            </td>
                        </tr>

                        <tr>
                            <th>
                                QTY
                            </th>
                            <td class="highlight amount">
                                {{ shipProd.amount }}
                            </td>

                        </tr>

                        <tr>
                            <th>
                                SKU
                            </th>
                            <td :class="shipProd.vender_code ? 'highlight' : ''">
                                {{ shipProd.vender_code }}
                            </td>

                        </tr>


                    </table>

                    <table class="prod-info">



                        <tr>
                            <th class="highlight">
                                COLOR
                            </th>
                            <td class="highlight color" colspan="5">
                                {{ shipProd.color }}
                            </td>
                        </tr>
                        <tr>
                            <th class="highlight">
                                SIZE
                            </th>
                            <td class="highlight size" colspan="5">
                                {{ shipProd.size }}
                            </td>

                        </tr>


                        <tr>
                            <th class="highlight">
                                NAME
                            </th>
                            <td class="highlight name" colspan="5">
                                {{ shipProd.name }}
                                <app-column
                                    header="상품명(영문)"
                                    horizontal
                                    header-align="right"
                                    body-align="left"
                                    body-size="medium"
                                    v-show="shipProd.name_eng"
                                >
                                    {{ shipProd.name_eng }}
                                </app-column>
                            </td>
                        </tr>

                        <tr>
                            <th>
                                수취인
                            </th>
                            <td class="mailbox">
                                {{ shipHouse.name }}
                            </td>
                            <th>
                                배송코드
                            </th>
                            <td class="mailbox">
                                {{ shipHouse.code }}
                            </td>
                            <th>
                                사서함
                            </th>
                            <td class="mailbox">
                                {{ shipProd.user_mailbox }}
                            </td>
                        </tr>

                    </table>


                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    components: {
        'img-zoom': require('../common/img-zoom.vue').default,

    },
    props: {
        // 배송상품
        shipProd: Object,

        // 배송 하우스
        shipHouse: Object,

    },
    data: function () {
        return {};
    },
    computed: {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.uk-card-default.simple-card  {
    border: 3px solid #999;
}
.title {
    display: inline-block;
    color: #000;
    font-size: 1.25rem;
    font-weight: bold;
    text-align: left;
    background-color: #ff0;


    .material-icons {
        font-size: 1.5rem;
    }
}

// 상품정보 테이블
.prod-info {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    th, td {
        text-align: center;
        border: 1px solid #cfcfcf;
        font-weight: normal;


        padding: 10px;
        color: #000;
    }

    th {
        font-size: 1.25rem;
        background-color: #fefefe;
        width: 6rem;

        .material-icons {
            vertical-align: middle;
            font-size: 1.75rem;
            color: #aaa;
        }

        &.highlight .material-icons {
            color: #1e87f0 !important;
        }

    }

    td {
        font-size: 1.75rem;
        color: #000;

        &.name, &.mailbox {
            font-size: 1.25rem;
        }


        &.color, &.size {
            font-weight: bold;
        }


        &.amount {
            font-size: 2.5rem;
            color: #ff0000 !important;
            font-weight: bold;

        }

        &.highlight {
            background-color: #ffffdd;
        }

        &.bold {
            font-weight: bold !important;
        }
    }

}


</style>